import { API, deleteRequest, getRequest, postRequest, putRequest } from '@/api/api';
import { generateSearchParams } from '@/utils/generate-search-params';

import { mapNotificationMethod } from './notification-settings.mappers';
import type {
  CreateNotificationMethodFormValues,
  NotificationMethod,
  NotificationMethodDto,
  NotificationMethodsFilters,
  UpdateNotificationMethodFormValues,
} from './notification-settings.types';

export const getNotificationMethods = async (
  filters?: NotificationMethodsFilters,
): Promise<NotificationMethod[]> => {
  const searchParams = generateSearchParams({ ...filters });
  const { data } = await getRequest<NotificationMethodDto[]>(
    API.NOTIFICATIONS,
    `notifications/methods?${searchParams}`,
  );
  return data.map(mapNotificationMethod);
};

export const getNotificationMethodById = async (id: string): Promise<NotificationMethod> => {
  const { data } = await getRequest<NotificationMethodDto>(
    API.NOTIFICATIONS,
    `notifications/methods/${id}`,
  );
  return mapNotificationMethod(data);
};

export const createNotificationMethod = async ({
  deviceId,
  deviceName,
  ...values
}: CreateNotificationMethodFormValues): Promise<NotificationMethod> => {
  const { data } = await postRequest<NotificationMethodDto, unknown>(
    API.NOTIFICATIONS,
    'notifications/methods',
    { ...values, device_id: deviceId, device_name: deviceName },
  );
  return mapNotificationMethod(data);
};

export const updateNotificationMethod = async ({
  id,
  ...values
}: UpdateNotificationMethodFormValues): Promise<NotificationMethod> => {
  const { data } = await putRequest<NotificationMethodDto, unknown>(
    API.NOTIFICATIONS,
    `notifications/methods/${id}`,
    values,
  );
  return mapNotificationMethod(data);
};

export const deleteNotificationMethod = async (id: string): Promise<void> => {
  await deleteRequest(API.NOTIFICATIONS, `notifications/methods/${id}`);
};
